const extraerId = (referencia) => {
    if (referencia == null) return null;
    if (typeof referencia === 'object') return referencia._id != null ? String(referencia._id) : null;
    return String(referencia);
};

const obtenerProfesionalCita = (cita, servicioPagoSeleccionado) => {
    const esMultiservicio = Array.isArray(cita?.servicios) && cita.servicios.length > 1;
    const profesionalSlot = servicioPagoSeleccionado?.servicioDetalle?.profesional;
    if (esMultiservicio && profesionalSlot != null) {
        return profesionalSlot;
    }
    return cita?.profesional ?? null;
};

export const detectarCambiosCitaVsVenta = ({
    cita,
    selectedSucursal,
    selectedProfesional,
    servicioPagoSeleccionado,
}) => {
    const vacio = {
        cambioSucursal: false,
        cambioProfesional: false,
        sucursalCita: null,
        sucursalVenta: null,
        profesionalCita: null,
        profesionalVenta: null,
    };

    if (!cita) return vacio;

    const sucursalCita = cita.sucursal ?? null;
    const sucursalVenta = selectedSucursal?.[0] ?? null;
    const profesionalCita = obtenerProfesionalCita(cita, servicioPagoSeleccionado);
    const profesionalVenta = selectedProfesional?.[0] ?? null;

    const sucursalCitaId = extraerId(sucursalCita);
    const sucursalVentaId = extraerId(sucursalVenta);
    const profesionalCitaId = extraerId(profesionalCita);
    const profesionalVentaId = extraerId(profesionalVenta);

    const cambioSucursal = sucursalVentaId != null
        && sucursalCitaId != null
        && sucursalVentaId !== sucursalCitaId;
    const cambioProfesional = profesionalVentaId != null
        && profesionalCitaId != null
        && profesionalVentaId !== profesionalCitaId;

    return {
        cambioSucursal,
        cambioProfesional,
        sucursalCita,
        sucursalVenta,
        profesionalCita,
        profesionalVenta,
    };
};

export const nombreDesdeReferencia = (referencia, catalogo = []) => {
    if (referencia == null) return '—';
    if (typeof referencia === 'object' && referencia.nombre) return referencia.nombre;
    const id = extraerId(referencia);
    if (!id) return '—';
    const encontrado = catalogo.find((item) => extraerId(item) === id);
    return encontrado?.nombre || '—';
};
